import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GraphFrame } from "shared-ui-components/nodeGraphSystem/graphFrame.js";
import { GraphNode } from "shared-ui-components/nodeGraphSystem/graphNode.js";
import { NodePort } from "shared-ui-components/nodeGraphSystem/nodePort.js";
import * as react from "react";
import { DataStorage } from "core/Misc/dataStorage.js";
import { FileButtonLineComponent } from "../../sharedComponents/fileButtonLineComponent.js";
import { LineContainerComponent } from "../../sharedComponents/lineContainerComponent.js";
import { CheckBoxLineComponent } from "../../sharedComponents/checkBoxLineComponent.js";
import { IsFramePortData } from "shared-ui-components/nodeGraphSystem/tools.js";
import { TextLineComponent } from "shared-ui-components/lines/textLineComponent.js";
import { TextInputLineComponent } from "shared-ui-components/lines/textInputLineComponent.js";
import { ButtonLineComponent } from "shared-ui-components/lines/buttonLineComponent.js";
import { SliderLineComponent } from "shared-ui-components/lines/sliderLineComponent.js";
import { InputsPropertyTabComponent } from "./inputsPropertyTabComponent.js";
import { McpSessionComponent } from "../mcpSession/mcpSessionComponent.js";
import { BlockTools } from "../../blockTools.js";
import { ForceWebGL1StorageKey } from "../../globalState.js";
import { OptimizerDebugMode, SmartFilterCoreVersion } from "smart-filters";
import { OnlyShowCustomBlocksDefaultValue } from "../../constants.js";
import { OptionsLine } from "shared-ui-components/lines/optionsLineComponent.js";
const OptimizerDebugOptions = [
    { label: "Off", value: 0 },
    { label: "Clamp Return Values", value: OptimizerDebugMode.ClampReturnValues },
];
/**
 * The property tab is used to edit the properties of the current node
 */
export class PropertyTabComponent extends react.Component {
    // private _modeSelect: React.RefObject<OptionsLineComponent>;
    constructor(props) {
        super(props);
        const optimize = this.props.globalState.optimizerEnabled?.value || null;
        this.state = {
            currentNode: null,
            currentFrame: null,
            currentFrameNodePort: null,
            currentNodePort: null,
            uploadInProgress: false,
            optimize,
        };
        // this._modeSelect = React.createRef();
    }
    componentDidMount() {
        this.props.globalState.stateManager.onSelectionChangedObservable.add((options) => {
            const { selection } = options || {};
            if (selection instanceof GraphNode) {
                this.setState({
                    currentNode: selection,
                    currentFrame: null,
                    currentFrameNodePort: null,
                    currentNodePort: null,
                });
            }
            else if (selection instanceof GraphFrame) {
                this.setState({
                    currentNode: null,
                    currentFrame: selection,
                    currentFrameNodePort: null,
                    currentNodePort: null,
                });
            }
            else if (IsFramePortData(selection)) {
                this.setState({
                    currentNode: null,
                    currentFrame: selection.frame,
                    currentFrameNodePort: selection.port,
                    currentNodePort: null,
                });
            }
            else if (selection instanceof NodePort) {
                this.setState({
                    currentNode: null,
                    currentFrame: null,
                    currentFrameNodePort: null,
                    currentNodePort: selection,
                });
            }
            else {
                this.setState({
                    currentNode: null,
                    currentFrame: null,
                    currentFrameNodePort: null,
                    currentNodePort: null,
                });
            }
        });
        this._onResetRequiredObserver = this.props.globalState.onResetRequiredObservable?.add(() => {
            this.forceUpdate();
        });
        if (this.props.globalState.optimizerEnabled) {
            this._onOptimizerEnabledChangedObserver = this.props.globalState.optimizerEnabled.onChangedObservable.add((value) => {
                this.setState({ optimize: value });
            });
        }
    }
    componentWillUnmount() {
        if (this._onResetRequiredObserver) {
            this._onResetRequiredObserver.remove();
        }
        if (this._onOptimizerEnabledChangedObserver) {
            this._onOptimizerEnabledChangedObserver.remove();
        }
    }
    async _loadAsync(_file) {
        if (this.props.globalState.engine && this.props.globalState.loadSmartFilterAsync) {
            const newSmartFilter = await this.props.globalState.loadSmartFilterAsync(_file, this.props.globalState.engine);
            if (newSmartFilter) {
                this.props.globalState.smartFilter = newSmartFilter;
                this.props.globalState.stateManager.onSelectionChangedObservable.notifyObservers(null);
                this.props.globalState.onResetRequiredObservable.notifyObservers(false);
                this.props.globalState.onClearUndoStack.notifyObservers();
            }
        }
    }
    _downloadSmartFilter() {
        if (this.props.globalState.downloadSmartFilter) {
            this.props.globalState.onSaveEditorDataRequiredObservable.notifyObservers();
            this.props.globalState.downloadSmartFilter();
        }
    }
    _copySmartFilter() {
        if (this.props.globalState.copySmartFilterToClipboard) {
            this.props.globalState.onSaveEditorDataRequiredObservable.notifyObservers();
            this.props.globalState.copySmartFilterToClipboard();
        }
    }
    async _pasteSmartFilterAsync() {
        if (this.props.globalState.pasteSmartFilterFromClipboardAsync) {
            this.props.globalState.onSaveEditorDataRequiredObservable.notifyObservers();
            await this.props.globalState.pasteSmartFilterFromClipboardAsync();
            this.props.globalState.onClearUndoStack.notifyObservers();
        }
    }
    _saveToSnippetServer() {
        this.setState({ uploadInProgress: true });
        try {
            this.props.globalState.onSaveEditorDataRequiredObservable.notifyObservers();
            this.props.globalState.saveToSnippetServer();
        }
        finally {
            this.setState({ uploadInProgress: false });
        }
    }
    render() {
        if (this.state.currentNode) {
            return (_jsxs("div", { id: "propertyTab", children: [_jsxs("div", { id: "header", children: [_jsx("img", { id: "logo", src: "https://www.babylonjs.com/Assets/logo-babylonjs-social-twitter.png", alt: "Babylon Logo" }), _jsx("div", { id: "title", children: "SMART FILTER EDITOR" })] }), this.state.currentNode?.renderProperties() || this.state.currentNodePort?.node.renderProperties()] }));
        }
        // if (this.state.currentFrameNodePort && this.state.currentFrame) {
        //     return (
        //         <FrameNodePortPropertyTabComponent
        //             globalState={this.props.globalState}
        //             stateManager={this.props.globalState.stateManager}
        //             frame={this.state.currentFrame}
        //             frameNodePort={this.state.currentFrameNodePort}
        //         />
        //     );
        // }
        // if (this.state.currentNodePort) {
        //     return <NodePortPropertyTabComponent stateManager={this.props.globalState.stateManager} nodePort={this.state.currentNodePort} />;
        // }
        // if (this.state.currentFrame) {
        //     return <FramePropertyTabComponent globalState={this.props.globalState} frame={this.state.currentFrame} />;
        // }
        const gridSize = DataStorage.ReadNumber("GridSize", 20);
        return (_jsxs("div", { id: "propertyTab", children: [_jsxs("div", { id: "header", children: [_jsx("img", { id: "logo", src: "https://www.babylonjs.com/Assets/logo-babylonjs-social-twitter.png", alt: "Babylon Logo" }), _jsx("div", { id: "title", children: "SMART FILTER EDITOR" })] }), _jsxs("div", { children: [_jsx(McpSessionComponent, { globalState: this.props.globalState }), _jsxs(LineContainerComponent, { title: "GENERAL", children: [_jsx(TextLineComponent, { label: "Version", value: SmartFilterCoreVersion }), _jsx(TextLineComponent, { label: "Help", value: "doc.babylonjs.com", underline: true, onLink: () => this.props.globalState.hostDocument.defaultView.open("https://doc.babylonjs.com/features/featuresDeepDive/smartFilters/", "_blank") }), _jsx(TextInputLineComponent, { label: "Name", lockObject: this.props.globalState.lockObject, target: this.props.globalState.smartFilter, propertyName: "name" }), _jsx(TextInputLineComponent, { label: "Namespace", lockObject: this.props.globalState.lockObject, target: this.props.globalState.smartFilter, propertyName: "namespace" }), _jsx(TextInputLineComponent, { label: "Comment", multilines: true, lockObject: this.props.globalState.lockObject, target: this.props.globalState.smartFilter, propertyName: "comments" })] }), _jsxs(LineContainerComponent, { title: "UI", children: [_jsx(ButtonLineComponent, { label: "Zoom to fit", onClick: () => {
                                        this.props.globalState.onZoomToFitRequiredObservable.notifyObservers();
                                    } }), _jsx(ButtonLineComponent, { label: "Reorganize", onClick: () => {
                                        this.props.globalState.onReOrganizedRequiredObservable.notifyObservers();
                                    } })] }), _jsxs(LineContainerComponent, { title: "OPTIONS", children: [_jsx(SliderLineComponent, { lockObject: this.props.lockObject, label: "Grid size", minimum: 0, maximum: 100, step: 5, decimalCount: 0, directValue: gridSize, onChange: (value) => {
                                        DataStorage.WriteNumber("GridSize", value);
                                        this.props.globalState.stateManager.onGridSizeChanged.notifyObservers();
                                        this.forceUpdate();
                                    } }), _jsx(CheckBoxLineComponent, { label: "Show grid", isSelected: () => DataStorage.ReadBoolean("ShowGrid", true), onSelect: (value) => {
                                        DataStorage.WriteBoolean("ShowGrid", value);
                                        this.props.globalState.stateManager.onGridSizeChanged.notifyObservers();
                                    } }), _jsx(CheckBoxLineComponent, { label: "Only show custom blocks", isSelected: () => DataStorage.ReadBoolean("OnlyShowCustomBlocks", OnlyShowCustomBlocksDefaultValue), onSelect: (value) => {
                                        DataStorage.WriteBoolean("OnlyShowCustomBlocks", value);
                                        this.props.globalState.onlyShowCustomBlocksObservable.notifyObservers(value);
                                    } }), this.props.globalState.optimizerEnabled && (_jsx(CheckBoxLineComponent, { label: "Optimize Smart Filter", isSelected: () => !!this.state.optimize, onSelect: (value) => {
                                        if (this.props.globalState.optimizerEnabled) {
                                            this.props.globalState.optimizerEnabled.value = value;
                                        }
                                    } })), this.props.globalState.optimizerEnabled && this.props.globalState.optimizerDebugMode && (_jsx(OptionsLine, { label: "Optimizer Debug Mode", target: {}, propertyName: "value", options: OptimizerDebugOptions, noDirectUpdate: true, extractValue: () => {
                                        return this.props.globalState.optimizerDebugMode?.value ? this.props.globalState.optimizerDebugMode.value : 0;
                                    }, onSelect: (newSelectionValue) => {
                                        if (this.props.globalState.optimizerDebugMode) {
                                            this.props.globalState.optimizerDebugMode.value = newSelectionValue ? newSelectionValue : null;
                                        }
                                    } })), this.props.globalState.onNewEngine && ( // NOTE: only display this option if the Editor controls creating the Engine
                                _jsx(CheckBoxLineComponent, { label: "Force WebGL v1", isSelected: () => this.props.globalState.forceWebGL1, onSelect: (value) => {
                                        if (window.confirm("Any unsaved changes will be lost. Do you want to continue?")) {
                                            localStorage.setItem(ForceWebGL1StorageKey, value ? "true" : "");
                                            window.location.reload();
                                        }
                                        else {
                                            // Re-apply the original value (this.props.globalState.forceWebGL1)
                                            this.forceUpdate();
                                        }
                                    } }))] }), (this.props.globalState.loadSmartFilterAsync ||
                            this.props.globalState.downloadSmartFilter ||
                            this.props.globalState.copySmartFilterToClipboard ||
                            this.props.globalState.pasteSmartFilterFromClipboardAsync ||
                            this.props.globalState.saveToSnippetServer) && (_jsxs(LineContainerComponent, { title: "FILE", children: [this.props.globalState.loadSmartFilterAsync && (_jsx(FileButtonLineComponent, { label: "Load", onClick: async (file) => await this._loadAsync(file), accept: ".json" })), this.props.globalState.downloadSmartFilter && (_jsx(ButtonLineComponent, { label: "Save", onClick: () => {
                                        this._downloadSmartFilter();
                                    } })), this.props.globalState.copySmartFilterToClipboard && (_jsx(ButtonLineComponent, { label: "Copy to Clipboard", onClick: () => {
                                        this._copySmartFilter();
                                    } })), this.props.globalState.pasteSmartFilterFromClipboardAsync && (_jsx(ButtonLineComponent, { label: "Paste from Clipboard", onClick: () => {
                                        if (window.confirm("Any unsaved changes will be lost. Do you want to continue?")) {
                                            // eslint-disable-next-line @typescript-eslint/no-floating-promises
                                            this._pasteSmartFilterAsync();
                                        }
                                    } })), this.props.globalState.saveToSnippetServer && (_jsx(ButtonLineComponent, { label: "Save to unique URL", isDisabled: this.state.uploadInProgress, onClick: () => {
                                        this._saveToSnippetServer();
                                    } }))] })), _jsx(InputsPropertyTabComponent, { lockObject: this.props.lockObject, globalState: this.props.globalState, inputs: BlockTools.GetInputBlocks(this.props.globalState.smartFilter) })] })] }));
    }
}
//# sourceMappingURL=propertyTabComponent.js.map